import Vue from "vue";
import Moment from "moment-mini";

Object.assign(Vue.config, {
  VERSION: process.env.VERSION,
  GOOGLE_CLIENTID: "953254316643-hgbje345vodabkot3795r5gm2nk8n6r4.apps.googleusercontent.com",
  FACEBOOK_CLIENTID: "423164797880055",

  WEBSITE: {
    ADDRESS: "D402 Brindavan Renaissance, Uttarahalli Main Road, Subramanyapura, Bengaluru, Karnataka 560061, India",
    COMPANY: "Arevuk Advisory Services Pvt Ltd.",
    COPYRIGHT_YEAR: Moment().format("Y")
  },

  goals: {
    default_risk_value: 5,
    base_returns: 7,
    inflation: 5,
    retirement_age: 60
  },

  returns: {
    fd: 6.5,
    savings: 3.5,
    gold: 3.8
  },

  PLAYSTORE_LINK:
    "https://play.google.com/store/apps/details?id=com.gooogle.android.kuvera.app&referrer=utm_source%3Dwebsite%26utm_medium%3Dwebsite%26utm_campaign%3Dwebsite",
  APPSTORE_LINK: "https://itunes.apple.com/us/app/kuvera-direct-mutual-fund/id1329701793",

  LOGOUT_TIMEOUT: 30 * 60 * 1000, // 30 minutes of inactivity
  REFRESH_AFTER: 60 * 60 * 1000, // after 15 minutes the data will be cleaned and new data will be fetched

  HNR_LINK: "https://goo.gl/bJPNwP",

  /**
   * Onboarding states for account setup
   */
  onboarding_state: {
    BEGINNING: 0,
    PRIMARY_APPLICANT_SET: 1,
    SECOND_APPLICANT_SET: 2,
    THIRD_APPLICANT_SET: 3,
    PORTFOLIO_EMAIL_CAPTURED: 5,
    REGISTRATION_COMPLETE: 13
  },

  kuvera_account_mode: {
    INDIVIDUAL: "sole",
    JOINT: "either"
  },

  user_pan_kyc_status: {
    ONLY_PAN_VERIFIED: 2,
    ALL_DETAILS_VERFIED: 1,
    PAN_NOT_KYC: 0
  },

  tax_residency_status: {
    RI: "resident_individual",
    NRI: "non_resident_individual"
  },

  kyc_residence_status: {
    resident_individual: "Indian",
    non_resident_individual: "Non Resident Indian",
    pio: "Person of Indian Origin",
    oci: "Overseas Citizen of India"
  },

  kyc_form_check_status: {
    KYC_FORM_FILLING : '1',
    KYC_FORM_SUBMITTED : '2',
    KYC_REJECTED_BY_KUVERA : '3',
    KYC_FORM_UPLOADING : '4',
    KYC_FORM_UPLOADED : '5',
    KYC_REJECTED_BY_CVLKRA : '6',
    KYC_VERIFIED_BY_CVLKRA : '7'
  },

  otp_size: 6,

  manage_request_status: {
    ACCEPTED: "accepted",
    WAITING: "waiting",
    REJECTED: "rejected",
    DELETED: "deleted"
  },

  //list of only accepted crisil ratings
  ratings_for_scheme: ["Low", "Moderately Low", "Moderate", "Moderately High", "High"],

  //image for the corresponding rating
  rating_image_map: {
    low_risk: "low_risk.gif",
    moderately_low_risk: "moderately_low_risk.gif",
    moderate_risk: "moderate_risk.gif",
    moderately_high_risk: "moderately_high_risk.gif",
    high_risk: "high_risk.gif"
  },

  insured_document_links: {
    ICICIPrudentialMutualFund_MF: "https://assets.kuvera.in/amc/ipru/SIP_plus_faq.pdf",
    BirlaSunLifeMutualFund_MF: "https://assets.kuvera.in/amc/absl/CSIP_WEB.PDF"
  },

  insured_multiplier_schedule: {
    ICICIPrudentialMutualFund_MF: `Year 1 : 10 times the monthly SIP Plus installment </br>
                                       Year 2 : 50 times the monthly SIP Plus installment </br>
                                       Year 3 onwards : 100 times the monthly SIP Plus installment`,
    BirlaSunLifeMutualFund_MF: `Year 1 : 10 times the monthly SIP Plus installment </br>
                                    Year 2 : 50 times the monthly SIP Plus installment </br>
                                    Year 3 onwards : 100 times the monthly SIP Plus installment`
  },

  //add only those tags whose icon needs to be shown
  tags_for_icons: ["top_rated", "top_searched", "investor", "instant", "insured", "elss", "smart"],

  // add the corresponding image for the icon-tag
  tag_image_map: {
    top_rated: "",
    top_searched: "top_searched.png",
    investor: "investor.png",
    instant: "rupee.png",
    insured: "",
    elss: "save-tax-2.svg",
    smart: "trade-smart.svg"
  },

  coins_required: {
    FAMILY_ACCOUNT: 200,
    SMART_SWITCH: 300,
    SMART_SWITCH_2: 100,
    TAX_HARVESTING: 499
  },

  CAS_frequency_update_list_mapping: [
    { label: "When requested", value: "manual" },
    { label: "month", value: "monthly" }
    // {label: "week", value: "weekly"}
  ],

  CAS_update_weekdays_mapping: [
    { label: "Sun", value: "Sunday" },
    { label: "Mon", value: "Monday" },
    { label: "Tue", value: "Tuesday" },
    { label: "Wed", value: "Wednesday" },
    { label: "Thu", value: "Thursday" },
    { label: "Fri", value: "Friday" },
    { label: "Sat", value: "Saturday" }
  ],

  CAS_update_days_list: ["Sun", "Mon", "Tue","Wed", "Thu", "Fri", "Sat"],

  mandate_types: {
    ISIP: "isip",
    ESIP: "esip",
    XSIP: "xsip"
  },

  mandate_title: {
    ISIP: "BillPay",
    ESIP: "E-NACH",
    XSIP: "OneClick"
  },

  holdings_sort_fields: {
    FUND_NAME: "fund_name",
    INVESTMENT: "investment",
    RETURNS: "returns",
    VALUE: "value"
  },

  status_codes: {
    FAILURE: "failure",
    SUCCESS: "success",
    PARAMS_INVALID: "params_invalid",
    VALIDATION_FAILED: "validation_failed",
    edit_sip: {
      CANNOT_PLACE_ORDER: "cannot_place_order",
      CANNOT_CANCEL_ORDER: "cannot_cancel_order",
      CANNOT_CANCEL_BOTH_ORDERS: "cannot_cancel_both_orders"
    },
    otp_errors: {
      OTP_INVALID: "OTP_invalid",
      OTP_REQUIRED: "OTP_required"
    }
  },

  holdings_sort_order: {
    ASCENDING: "ascending",
    DESCENDING: "descending"
  },

  affiliate_pivot_months: 3,

  coin_amount_multiplier: 1,

  purchase_tax_percent: 18,

  isMobile: navigator.userAgent.match(/Android|iPhone/i) && !navigator.userAgent.match(/iPod|iPad/i) ? true : false,

  //Here year is the format "[y-1]-[y]". Like (year 2002 means 2001-2002)
  COST_INFLATION_INDEX: {
    2002: 100,
    2003: 105,
    2004: 109,
    2005: 113,
    2006: 117,
    2007: 122,
    2008: 129,
    2009: 137,
    2010: 148,
    2011: 167,
    2012: 184,
    2013: 200,
    2014: 220,
    2015: 240,
    2016: 254,
    2017: 264,
    2018: 272,
    2019: 280,
    2020: 288
  },

  get_coins_features: ["tax-harvesting", "smart-trade", "family-account"],

  newsAndAdvice: [
    {
      img: "https://kuvera.in/blog/wp-content/uploads/2019/07/MostBought-1.png",
      link: "https://kuvera.in/blog/portfolio-clutter-forex-sebi-other-mf-news-2/",
      desc: "The FM has committed to grow our economy to $5 Trillion in 5 years. Do you think it is possible?"
    },
    {
      img: "https://kuvera.in/blog/wp-content/uploads/2019/06/Capture-5.png",
      link: "https://kuvera.in/blog/save-up-to-%e2%82%b910000-in-ltcg-taxes-with-tax-harvesting/",
      desc: "Save up to ₹10,000 in Long Term Capital Gains (LTCG) taxes every year by harvesting your LTCG diligently."
    },
    {
      img: "https://kuvera.in/blog/wp-content/uploads/2019/02/Capture.png",
      link: "https://kuvera.in/blog/in-investing-the-simplest-things-are-the-hardest/",
      desc:
        "Zen and the art of investing – simple stories to understand markets and our reaction to them. Read how to make investing easy."
    }
  ],

  goal_handles: ["house", "growmymoney", "car", "taxsaver", "retirement", "kidseducation", "vacation", "anniversary"],

  faqbot_tags: {
    'pricing': 'pricing',
    'explore-gold': 'gold'
  },
  
  buyGoldCap: 190000,
  buyGoldPerDayCap: 200000,
  buyGoldTotalTransactionsCap: 2000000,
  isMobileViewPort: window.innerWidth <= 767 ? true : false,
  isTabletViewPort: (window.innerWidth >= 768 && window.innerWidth <= 991) ? true : false,
  buyGoldTimerDuration: "00:05:00",
  sellGoldTimerDuration: "00:05:00",

  preCampaignGoldOffersStates: {
    '2019-09-26': {
      splash_src: 'assets/img/gold-offer-splash/offer-splash-day-5.svg',
      spotlight: {
        header: 'The October 5Cr Gold Rush!',
        para: '5 days to go!'
      }
    },
    '2019-09-27': {
      splash_src: 'assets/img/gold-offer-splash/offer-splash-day-4.svg',
      spotlight: {
        header: 'The October 5Cr Gold Rush!',
        para: '4 days to go!'
      }
    },
    '2019-09-28': {
      splash_src: 'assets/img/gold-offer-splash/offer-splash-day-3.svg',
      spotlight: {
        header: 'The October 5Cr Gold Rush!',
        para: '3 days to go!'
      }
    },
    '2019-09-29': {
      splash_src: 'assets/img/gold-offer-splash/offer-splash-day-2.svg',
      spotlight: {
        header: 'The October 5Cr Gold Rush!',
        para: '2 days to go!'
      }
    },
    '2019-09-30': {
      splash_src: 'assets/img/gold-offer-splash/offer-splash-day-1.svg',
      spotlight: {
        header: 'The October 5Cr Gold Rush!',
        para: '1 day to go!'
      }
    }
  }
});
